import { h } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import {
    Box, Grid, Typography, Paper, TextField, Button, Stack, InputAdornment, Divider,
    OutlinedInput,
} from "@mui/material";

import WarningIcon from "@mui/icons-material/Warning";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

export default function Offers({ uid }) {

    const [state, setState] = useState({});
    const [counter, setCounter] = useState(false);
    const handleAccept = (b_uid) => {

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };
        fetch("/api/acceptbid/" + b_uid, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        window.location.href = "/11d1355181ac4376a09980601b420617/" + uid;
                        break;

                    case "err":
                        break;
                    default:
                        break;
                }
            });
    };
    useEffect(() => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };
        fetch("/api/e743b223ddb74c8c9fecfc1cc81b05f4/" + uid, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        setState((state) => ({
                            ...state,
                            bids: res.pld
                        }))

                        break;
                    case "err":
                        break;
                    default:
                        break;
                }
            });
    }, []);
    const handleChange = (event) => {
        //console.log(state);
        if (event.target.name === "amount") {
            var amt = event.target.value;
            if (amt === "") {
                return;
            }
            const amnt = Math.min(parseInt(amt, 10), state.price);


            const ln = state.price - amnt;

            setState({
                ...state,
                [event.target.name]: amnt,
                loan: ln,
            });
        } else {
            setState({ ...state, [event.target.name]: event.target.value });
        }
    };
    const manageSubmit = () => {

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },

            body: JSON.stringify({
                ...state,
                uid: params.uid,
            }),
        };
        var url;

        url = "/api/newbid_vn";

        fetch(url, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        window.location.href = "/11d1355181ac4376a09980601b420617/" + uid;
                        break;

                    case "err":
                        break;
                    default:
                        break;
                }
            });
    };
    if (!state.bids) return

    return (
        <div style="margin-top: 40px; padding-left: 100px; padding-right: 100px;">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Paper style="padding: 10px">
                        <Typography variant="h5">Mes offres</Typography>
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    {state.bids.map((b) => {
                        return (<Paper style="padding: 10px">
                            <Stack>
                                <Typography variant="h5" gutterBottom>
                                    Voulez-vous vraiment accepter l'offre à {b.p} € de {b.u} ?
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    Offre valable jusqu'au {b.td}
                                </Typography>


                                <Typography variant="h5" gutterBottom>
                                    Fonds propres {b.a} €
                                </Typography>

                                <Typography variant="h5" gutterBottom>
                                    Montant financé {b.l} €
                                </Typography>

                                <Typography variant="h5" gutterBottom>
                                    Condition suspensive de financement {b.sp ? "Oui" : "Non"}
                                </Typography>
                                {!counter && <Box display="flex" justifyContent="space-between" alignItems="space-between">
                                    <Box>
                                        <Button variant="contained" onClick={() => handleAccept(b.uid)} style="margin: 10px;">
                                            OUI
                                        </Button>
                                    </Box>
                                    {/* <Box>
                                        <Button variant="outlined" onClick={() => { window.location.href = "/11d1355181ac4376a09980601b420617/" + uid; }} style="margin: 10px;">
                                            Je vais réfléchir
                                        </Button>
                                    </Box> */}
                                    <Box>
                                        <Button variant="contained" onClick={() => { setCounter(true) }} style="margin: 10px;">
                                            Je contre-propose
                                        </Button>
                                    </Box>
                                </Box>}
                            </Stack>
                            {counter && <Stack spacing={1}>
                                <Divider />
                                <Box display="flex" justifyContent="flex-start" alignItems="center">
                                    <Box>
                                        <WarningIcon />
                                    </Box>
                                    <Box>
                                        <Typography style="margin-left: 8px; ">La nouvelle proposition annule la précédente</Typography>
                                    </Box>
                                </Box>
                                <Box display="flex" justifyContent="flex-start" alignItems="center">
                                    <Box>
                                        <AccessTimeIcon />
                                    </Box>
                                    <Box>
                                        <Typography style="margin-left: 8px; height: 24px;">
                                            {`Offre valable jusqu'au ${b.td}`}
                                        </Typography>
                                    </Box>
                                </Box>

                                <Box display="flex" justifyContent="flex-start" alignItems="center">
                                    <Box>
                                        <Typography>Montant de l'offre</Typography>
                                    </Box>
                                    <Box>
                                        <OutlinedInput
                                            id="price"
                                            name="price"
                                            value={state.price}
                                            onChange={handleChange}
                                            endAdornment={<InputAdornment position="end">€</InputAdornment>}
                                            aria-describedby="outlined-rate-helper-text"
                                            inputProps={{
                                                "aria-label": "rate",
                                            }}
                                            labelWidth={0}
                                            size="small"
                                            margin="dense"
                                            placeholder="Prix"
                                            style={{
                                                marginLeft: 10,
                                                marginRight: 10,
                                            }}
                                        />
                                    </Box>
                                </Box>
                                <Box display="flex" justifyContent="space-between" alignItems="space-between">
                                    <Box>
                                        <Button
                                            onClick={() => { setCounter(false) }}
                                            variant="contained">
                                            Annuler
                                        </Button>
                                    </Box>
                                    <Box>
                                        <Button
                                            onClick={manageSubmit}
                                            variant="contained">
                                            Proposer
                                        </Button>
                                    </Box>
                                </Box>

                            </Stack>}
                        </Paper>)

                    })}
                </Grid>
            </Grid>
        </div>
    );

}
